import styles from './BioImageItem.module.css'
import noImage from '../../../../Img/Biometric/shot.svg'
import useApiQuery from "../../../../ApiQuery/UseApiQuery";
import {useRef, useState} from "react";
import WaitLoader from "../../../../WaitLoader/WaitLoader";

interface IBioImageItemProps
{
    loading:boolean
    img:string
    imgCss?:string
    onClick:()=>void
}
export default function BioImageItem({img,loading,imgCss,onClick}:IBioImageItemProps)
{
    const [ldrDummy,rsDummy,exDummy] = useApiQuery("/","post",useRef(null));
    const [image, setImage] = useState(img)
    //console.log("img",img)
    return(
        <div className={styles.mainCont}>
            <WaitLoader loading={loading } api={rsDummy} onlyLoading={true} >
                <img src={img} alt={"photo"} className={imgCss ? imgCss : ""}
                    onClick={onClick}
                />
            </WaitLoader>
        </div>
    )
}